import axios from "../request";

/**
 * 物资管理模块接口
*/
export default {
  /**
   * 搅拌站原料模块接口
  */ 

  // 获取原料数据总量
  getAllmixMaterialData: () =>
    axios.post('/materials/mixMaterial/mixTotalCount'),

  // 查询搅拌站原料管理信息
  searchStirstandList: (params) =>
    axios({
      method: 'post',
      url: '/materials/mixMaterial/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        startTime: params.startTime ? `${params.startTime} 00:00:00` : '',
        endTime: params.endTime ? `${params.endTime} 23:59:59` : ''
      }
    }),
  // 获取原料信息
  getRawMaterialData: (params) =>
    axios.post('/materials/mixMaterial/info', params),
  // 添加 修改 搅拌站原料信息
  insertStirstandInfo: (params) =>
    axios.post('/materials/mixMaterial/addMixMaterial', params),
  // 删除搅拌站原料信息
  deleteStirstandInfo: (params) =>
    axios.post('/materials/mixMaterial/delete', params),

  /**
   * 进场称重记录
   */
  //查询列表接口
  searchWeighRecordsList: (params) =>
    axios.post('/materials/weigh/queryAllWeigh', params),


  /**
   * 备品备件模块接口
  */
  // 查询备品备件列表信息
  SEARCHSPAREPARTLIST: (params) =>
    axios({
      method: 'post',
      url: '/materials/spare/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        spareNum: params.spareNum,
        spareName: params.spareName
      }
    }),
  // 添加备品备件信息
  INSERTSPAREPARTINFO: (params) =>
    axios.post('/materials/spare/addSpare', params),
  // 修改备品备件信息
  UPDATESPAREPARTINFO: (params) =>
    axios.post('/materials/spare/addSpare', params),
  // 删除备品备件信息
  DELETESPAREPARTINFO: (params) =>
    axios.post('/materials/spare/delete', params),
  
  /**
   * 搅拌站原料管理（入库）
   */
  // 搅拌站入库管理列表
  mixingInventLists: (params) =>
    axios.post('/materials/mixingstationstorage/selectAllList', params),
  // 搅拌站入库管理导出
  mixingInventExports: (params) =>
    axios({
      method: 'post',
      url: '/materials/mixingstationstorage/export',
      responseType: 'blob',
      data: params
  }),
  // 搅拌站入库管理新增
  mixingInventAdd: (params) =>
    axios.post('/materials/mixingstationstorage/insert', params),

  /**
   * 搅拌站原料管理（库存）
   */
  // 搅拌站库存列表
  mixingRepertLists: (params) =>
    axios.post('/materials/mixingstationstorage/selectInventoryList', params),
  //搅拌站（库存校正）
  mixingCheckInvents: (params) =>
    axios.post('/materials/mixingstationstorage/inventoryCorrection', params),

  /**
   * 搅拌站原料管理（校正记录）
   */
  //校正记录列表
  mixingCheckRecords: (params) =>
    axios.post('/materials/mixingstationstorage/selectInventoryRecordList', params),
  //校正记录导出按钮
  mixingChecksexports: (params) =>
    axios({
      method: 'post',
      url: '/materials/mixingstationstorage/exportInventoryRecord',
      responseType: 'blob',
      data: params
  }),
  
  /**
   * 搅拌站原料管理（消耗记录）
   */
  //消耗记录列表
  mixingCostsRecords: (params) =>
   axios.post('/materials/mixingstationstorage/selectAllConsumptionList', params),
 //消耗记录导出按钮
  mixingCostsExports: (params) =>
   axios({
     method: 'post',
     url: '/materials/mixingstationstorage/exportAllConsumptionList',
     responseType: 'blob',
     data: params
 }),
 /**
  * 搅拌站生产线料仓库存
  */
  searchProductLinesInvents: (params) =>
    axios.post('/materials/jnmixingplant/jnWarehouseInventoryList', params),
  //搅拌站生产线当前物料库存情况
  searchProductLinesCurrent: (params) =>
    axios.post('/materials/jnmixingplant/tjnRawMaterialList', params),
  //当日来料质检列表
  searchTodayQualityList: (params) =>
    axios.post('/materials/jnmixingplant/tjnQualityInspectionList', params),
  //当日各料仓库存与消耗数据
  searchTodayCostList: (params) =>
    axios.post('/materials/jnmixingplant/tjnWarehouseConsumptionList', params),

  /* 预埋件管理 */
  embedded: {
    // 库存管理
    inventGetLists: params => // table列表
        axios.post('/materials/embedmentInventoryManagement/findAll', params),
    inventCheck: params => // 库存校正
        axios.post('/materials/embedmentInventoryManagement/inventoryCorrection', params),
    inventPresAlarm: params => // 预报警设置
        axios.post('/materials/embedmentInventoryManagement/alarmSet', params),
    inventExportxls: params => // 导出
        axios({
            method: 'post',
            url: '/materials/embedmentInventoryManagement/export',
            responseType: 'blob',
            data: params
        }),
    // 入库记录
    incomeGetLists: params => // talbe列表
        axios.post('/materials/embedmentInsetRecord/embedmentRecordList', params),
    incomeInsert: params => // 新增
        axios.post('/materials/embedmentInsetRecord/insert', params),
    incomeUpdate: params => // 修改更新
        axios.post('/materials/embedmentInsetRecord/update', params),
    incomeDel: params => // 修改回显
        axios.get('/materials/embedmentInsetRecord/embedmentRecordDel', { params }),
    incomeExportxls: params => // 导出
        axios({
            method: 'post',
            url: '/materials/embedmentInsetRecord/export',
            responseType: 'blob',
            data: params
        }),
    incomeExportXls: params => //导出模板
        axios({
        method: 'post',
        url: '/materials/embedmentInsetRecord/recordExportTemplate',
        responseType: 'blob',
        params: params
    }),
    incomeInXls: params => //导入Excel
        axios.post('/materials/embedmentInsetRecord/variateExcel', params),

    // 预埋件种类
    typeGetLists: params => // table列表
        axios.post('/materials/embedmentGoods/findAll', params),
    typeInsert: params => // 新增
        axios.post('/materials/embedmentGoods/insert', params),
    typeUpdate: params => // 修改更新
      axios.post('/materials/embedmentGoods/update', params),
    typeDetail: params => // 修改回显
        axios.get('/materials/embedmentGoods/findEntity', { params }),
    typeModels: params => // 类别
        axios.get('/materials/embedmentGoods/getType', { params }),
    // 消耗记录
    costGetLists: params => // table列表
      axios.post('/materials/embedmentInsetRecord/embedmentRecordOutList', params),
    costInser: params => // table列表
      axios.post('/materials/embedmentInsetRecord/insert', params),
    costUpdate: params => // table列表
      axios.post('/materials/embedmentInsetRecord/update', params),
    costDel: params => // table列表
      axios.get('/materials/embedmentInsetRecord/embedmentRecordDel', { params }),
    // 校正记录
    checkGetLists: params => // 修改回显
        axios.post('/materials/embedmentCorrection/inventoryList', params),    
  },
}

